import { useForm } from "react-hook-form";

import Facebook from "../../../public/images/Facebook";
import Location from "../../../public/images/Location";
import MailOutline from "../../../public/images/MailOutline";
import PhoneOutline from "../../../public/images/PhoneOutline";
import Twitter from "../../../public/images/Twitter";
import Youtube from "../../../public/images/Youtube";

import "./contacts.scss";

export default function Contacts() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    console.log("FORM DATA:", data);
  };
  return (
    <div className="contacts">
      <div className="contacts__form">
        <div className="contacts__form__title">
          <h2>Contact us</h2>
          <p>Send us your request and we will contact you within 24 hours.</p>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <input
            placeholder="Name"
            {...register("name", { required: "Name is required" })}
          />
          {errors.name && <p>{errors.name.message}</p>}

          <input
            placeholder="Email"
            {...register("email", {
              required: "Email is required",
              pattern: {
                value: /\S+@\S+\.\S+/,
                message: "Invalid email address",
              },
            })}
          />
          {errors.email && <p>{errors.email.message}</p>}

          <textarea
            placeholder="Message"
            {...register("message", { required: "Message cannot be empty" })}
          />
          {errors.message && <p>{errors.message.message}</p>}

          <button type="submit">Send</button>
        </form>
      </div>
      <div className="contacts__info">
        <iframe
          title="Our office location on the map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2803.873539101951!2d28.846457122767053!3d47.04204245648624!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40c97dab25728b1f%3A0x6b4220142f7b1ede!2zMSwg0JrQsNC70Y8g0J7RgNGF0LXRjtC70YPQuSAyMCwgQ2hpyJlpbsSDdSwg0JzQvtC70LTQvtCy0LA!5e1!3m2!1sru!2s!4v1771261993720!5m2!1sru!2s"
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
        <div className="contacts__info__links">
          <a href="tel:+37378666677">
            <PhoneOutline color="#626166" /> +373-78-6666-77
          </a>
          <a href="tel:+37378666677">
            <MailOutline color="#626166" />
            info@x-cloud.info
          </a>
          <a href="tel:+37378666677">
            <Location color="#626166" />
            Kalya Orheiului 20/1, Chisinau Moldova
          </a>
        </div>
        <div className="contacts__info__media">
          <a href="tel:+37378666677">
            <Twitter />
          </a>
          <a href="tel:+37378666677">
            <Facebook />
          </a>
          <a href="tel:+37378666677">
            <Youtube />
          </a>
        </div>
      </div>
    </div>
  );
}
